var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container reportDetail" }, [
    _c(
      "div",
      { staticClass: "handle-box" },
      [
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.currentTab,
              callback: function ($$v) {
                _vm.currentTab = $$v
              },
              expression: "currentTab",
            },
          },
          [
            _vm._l(
              _vm.feedbackInfo.feedbackReports,
              function (report, key, index) {
                return _c(
                  "el-tab-pane",
                  {
                    key: index,
                    attrs: {
                      label: report.reportNo == null ? "NEW" : report.reportNo,
                      name: index,
                    },
                  },
                  [
                    _c("ReportDetail_ReportItem", {
                      attrs: {
                        feedback: _vm.feedbackInfo.feedback,
                        disabled: "",
                      },
                      model: {
                        value: _vm.feedbackInfo.feedbackReports[key],
                        callback: function ($$v) {
                          _vm.$set(_vm.feedbackInfo.feedbackReports, key, $$v)
                        },
                        expression: "feedbackInfo.feedbackReports[key]",
                      },
                    }),
                  ],
                  1
                )
              }
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("storeFeedback.report.feedbackDetail"),
                  name: "feedbackInfo.feedbackReports.length",
                },
              },
              [
                _c("ReportDetail_feedbackDetail", {
                  model: {
                    value: _vm.feedbackInfo.feedback,
                    callback: function ($$v) {
                      _vm.$set(_vm.feedbackInfo, "feedback", $$v)
                    },
                    expression: "feedbackInfo.feedback",
                  },
                }),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }